module.exports = __webpack_public_path__ + "static/img/7_03.5eaf32cc.png";